import MuiButton from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import React from 'react';

import { componentIdStringGenerator } from '../../../helpers';

const Button = (props) => {
  const { loading, ...otherProps } = props;

  return (
    <MuiButton
      color="primary"
      variant="contained"
      disabled={loading}
      {...otherProps}
      id={componentIdStringGenerator('Button', props.id ? props.id : props.children)}
    />
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
  loading: PropTypes.bool,
};

export default Button;
